import { useCAPartner } from "@/contexts/CAPartnerContext";
import { Badge } from "@/components/ui/badge";
import { IndianRupee } from "lucide-react";

const commStatusCfg = {
  pending: { label: "Pending", color: "bg-muted text-muted-foreground" },
  approved: { label: "Approved", color: "bg-accent/10 text-accent border-accent/20" },
  paid: { label: "Paid", color: "bg-success/10 text-success border-success/20" },
};

export default function PartnerCommissionTable() {
  const { commissions } = useCAPartner();

  return (
    <div className="p-5 rounded-lg bg-card border border-border shadow-card">
      <h3 className="text-sm font-semibold text-foreground mb-3 flex items-center gap-2">
        <IndianRupee className="h-4 w-4 text-accent" /> Commissions ({commissions.length})
      </h3>
      <div className="space-y-2 max-h-[360px] overflow-y-auto pr-1">
        {commissions.map((cm) => {
          const cfg = commStatusCfg[cm.status];
          return (
            <div key={cm.id} className="flex items-center justify-between p-3 rounded-lg bg-muted/20 border border-border/50">
              <div className="min-w-0 flex-1">
                <p className="text-sm font-medium text-foreground truncate">{cm.clientName}</p>
                <p className="text-xs text-muted-foreground">
                  <span className="capitalize">{cm.plan}</span> · ₹{cm.subscriptionAmount} × {Math.round(cm.commissionRate * 100)}% · {cm.month}
                </p>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-sm font-bold text-foreground">₹{cm.commissionAmount}</span>
                <Badge variant="outline" className={`text-[10px] ${cfg.color}`}>{cfg.label}</Badge>
              </div>
            </div>
          );
        })}
        {commissions.length === 0 && (
          <p className="text-sm text-muted-foreground text-center py-6">No commissions yet</p>
        )}
      </div>
    </div>
  );
}
